var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closed-beta-bar"},[_c('h2',{staticClass:"closed-beta-title"},[_vm._v(" Currently closed Beta. Early access available. ")])])}]

export { render, staticRenderFns }